import AnimalesTable from './animales-table';
export default AnimalesTable;